module.exports = __webpack_public_path__ + "static/media/settings.036fd1b1.svg";